export class StudyTrackingModel {
  Status: string;
  Date: Date;
  NameBy: string;
  NameTo: string;
}
